import { useState } from 'react';
import InfoIcon from '@mui/icons-material/Info';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { StyledIconButton, ModalContent } from './InfoIcon.styled';
import { InfoIconProps } from './InfoIcon.types';
import { useHelpContent } from './useHelpContent';

export function InfoIconComponent({
  resourceId,
  modalTitle,
  modalWidth = 400,
  modalMaxHeight = '80vh',
  iconSize = 'small',
  iconColor = 'primary',
  className,
}: InfoIconProps) {
  const [isOpen, setIsOpen] = useState(false);
  const { getHelpContent, parseContent } = useHelpContent();

  const helpContent = getHelpContent(resourceId);

  if (!helpContent) {
    return null;
  }

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: modalWidth,
    maxHeight: modalMaxHeight,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 1,
    overflow: 'auto',
  };

  return (
    <>
      <StyledIconButton
        onClick={handleOpen}
        className={className}
        color={iconColor}
        size={iconSize}
        data-testid="info-icon-button"
      >
        <InfoIcon fontSize={iconSize} data-testid="info-icon" />
      </StyledIconButton>

      <Modal
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="help-modal-title"
        data-testid="info-modal"
      >
        <Box sx={modalStyle} data-testid="info-modal-content">
          <Typography 
            id="help-modal-title" 
            variant="h6" 
            component="h2" 
            gutterBottom
            data-testid="info-modal-title"
          >
            {modalTitle || helpContent.title}
          </Typography>
          <ModalContent
            dangerouslySetInnerHTML={{
              __html: parseContent(helpContent.content),
            }}
            data-testid="info-modal-body"
          />
        </Box>
      </Modal>
    </>
  );
} 